import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import cx from "classnames";
import { createContext, useContext, useState } from "react";
import styles from "./tabs.module.css";
var TabsContext = /*#__PURE__*/ createContext({
    activeTab: 1,
    setActiveTab: function() {
        return null;
    }
});
export var useTabs = function() {
    return useContext(TabsContext);
};
export var Tabs = function(param) {
    var children = param.children;
    var ref = useState(1), activeTab = ref[0], setActiveTab = ref[1];
    return /*#__PURE__*/ _jsx(TabsContext.Provider, {
        value: {
            activeTab: activeTab,
            setActiveTab: setActiveTab
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: styles["tabsWrapper"],
            children: children
        })
    });
};
export var TabButton = function(param) {
    var tabOrderNumber = param.tabOrderNumber, children = param.children;
    var ref = useTabs(), activeTab = ref.activeTab, setActiveTab = ref.setActiveTab;
    var isActive = activeTab === tabOrderNumber;
    var trackEvent = useAnalytics().trackEvent;
    var handleClick = function(tabOrderNumber) {
        trackEvent({
            eventName: "Personalised Component",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "Personalised Component",
                    label: tabOrderNumber === 1 ? "Recently Viewed tab" : "You Might Like tab",
                    action: "Tab Clicked"
                }
            }
        });
        setActiveTab(tabOrderNumber);
    };
    var _obj;
    return /*#__PURE__*/ _jsx("button", {
        id: "tab-".concat(tabOrderNumber),
        type: "button",
        role: "tab",
        className: cx(styles["tabButton"], (_obj = {}, _define_property(_obj, styles.tabButtonLeft, tabOrderNumber === 1), _define_property(_obj, styles.tabButtonRight, tabOrderNumber === 2), _obj)),
        "aria-selected": isActive,
        "aria-controls": "tabpanel-".concat(tabOrderNumber),
        tabIndex: 0,
        onClick: function() {
            return handleClick(tabOrderNumber);
        },
        children: children
    });
};
export var TabPanel = function(param) {
    var tabOrderNumber = param.tabOrderNumber, children = param.children;
    var activeTab = useTabs().activeTab;
    var isActiveTab = activeTab === tabOrderNumber;
    var _obj;
    return /*#__PURE__*/ _jsx("div", {
        id: "tabpanel-".concat(tabOrderNumber),
        role: "tabpanel",
        tabIndex: isActiveTab ? 0 : -1,
        "aria-labelledby": "tab-".concat(tabOrderNumber),
        className: cx(styles["tabPanel"], (_obj = {}, _define_property(_obj, styles.tabPanelIsHidden, !isActiveTab), _define_property(_obj, styles.tabPanelLeft, activeTab === 1), _define_property(_obj, styles.tabPanelRight, activeTab === 2), _obj)),
        children: isActiveTab ? children : null
    });
};
export var TabButtonList = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        role: "tablist",
        "aria-labelledby": "tablist-1",
        className: styles["tabButtonList"],
        children: children
    });
};
